import { useEffect, useState } from "react";

export function usePublicNavScroll(threshold = 8) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > threshold);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return isScrolled;
}

export function getPublicNavClassName(styles, { menuOpen = false, isScrolled = false } = {}) {
  return [
    styles.nav,
    isScrolled ? styles.navScrolled : "",
    menuOpen ? styles.navMenuOpen : "",
  ]
    .filter(Boolean)
    .join(" ");
}
